export default __webpack_public_path__ + "static/media/Website.f0330e30.svg";